import { useState } from "react";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import {
  AiOutlineLike,
  AiOutlineDislike,
  AiFillDislike,
  AiFillLike,
} from "react-icons/ai";
import Checkbox from "../../form/checkbox";
import { createFeedback } from "../../../services/test";
import Textarea from "../../form/textarea";
import LoadingButton from "../../common/loadingButton";

const UserComment = () => {
  const { id } = useParams();
  const [isLikedLoading, setIsLikedLoading] = useState<boolean>(false);
  const [feedbackLoading, setFeedbackLoading] = useState<boolean>(false);
  const [isFeedbackComplete, setIsFeedbackComplete] = useState<boolean>(false);
  const [checkedItems, setCheckedItems] = useState<[]>([]);
  const [userFeedback, setUserFeedback] = useState<any>(null);

  const handleCheckboxChange = (id: string) => {
    setCheckedItems((prev: any) => {
      if (prev.includes(id)) {
        return prev.filter((item: any) => item !== id);
      } else {
        return [...prev, id];
      }
    });
  };

  const commentItems = [
    {
      title: "اطلاعات آزمایش به درستی استخراج نشده بود",
      value: "Incorrect_extraction",
    },
    {
      title: "تحلیل آزمایش به اندازه کافی کامل نبود",
      value: "incompleteness_analysis",
    },
    {
      title: "نتیجه تحلیل آزمایش درست نبود",
      value: "Inaccuracy_analysis",
    },
  ];

  const fetchFeedback = (type: boolean) => {
    setIsLikedLoading(true);
    if (userFeedback === null) {
      createFeedback(Number(id), type).then((res) => {
        if (res.status === 201) {
          setIsLikedLoading(false);
        }
      });
      setUserFeedback(type);
    }
  };

  const { handleSubmit, formState, control, ...form } = useForm();

  const onSubmit = ({ feedback }: { feedback?: string }) => {
    setFeedbackLoading(true);

    const params = feedback
      ? [Number(id), userFeedback, checkedItems, feedback]
      : [Number(id), userFeedback, checkedItems];

    //@ts-ignore
    createFeedback(...params)
      .then((res) => {
        if (res.status === 201) {
          setFeedbackLoading(false);
          toast.success("نظر شما درباره تحلیل این آزمایش ارسال شد.");
          setIsFeedbackComplete(true);
        }
      })
      .catch((err) => toast.error("مشکلی در ثبت نظر شما پیش آمد."));
  };

  if (isFeedbackComplete) {
    return (
      <div className="flex-1 bg-pr_primary rounded-xl p-6 mt-5 lg:mt-6 w-full">
        <h2 className="mt-5 font-rokh font-[900] text-2xl text-center text-white">
          نظرسنجی درباره تحلیل این آزمایش:
        </h2>

        <p className="mx-auto my-8 font-rokh font-[700] text-white text-center lg:text-xl">
          نظر شما درباره تحلیل این آزمایش برای ما ارسال شد.
          <br /> ممنون از همراهی ارزشمندت
        </p>
      </div>
    );
  }
  return (
    <div className="flex-1 bg-pr_primary rounded-xl p-6 mt-5 lg:mt-6 w-full">
      <div className="flex flex-col justify-between mt-2 mb-4">
        <h2 className="mt-2 font-rokh font-[900] text-lg lg:text-2xl text-center text-white">
          نظرسنجی درباره تحلیل این آزمایش:
        </h2>
        <p className="font-rokh font-[700] text-sm lg:text-lg text-center text-white">
          اگه نظرت رو درباره این تحلیل بهمون بگی، می‌تونیم بادی‌بان رو مطابق
          پیشنهاداتت خیلی بهتر کنیم.
        </p>
        <div className="flex items-center justify-center gap-3 lg:w-auto w-full mt-10">
          <button
            disabled={userFeedback === false || isLikedLoading}
            onClick={() => fetchFeedback(true)}
            className="btn btn-primary bg-white hover:bg-pr_green hover:shadow-xl rounded-xl min-w-[150px] lg:min-w-[180px] p-1 flex items-center justify-center duration-500 border-0 text-black"
          >
            {userFeedback === true ? (
              <div className="flex items-center gap-3 px-3">
                <h6>تحلیل درست</h6>
                <AiFillLike size={25} style={{ color: "text-pr_primary" }} />
              </div>
            ) : (
              <div className="flex items-center gap-3 px-3">
                <h6>تحلیل درست</h6>
                <AiOutlineLike size={25} style={{ color: "text-pr_primary" }} />
              </div>
            )}
          </button>
          <button
            disabled={userFeedback || isLikedLoading}
            onClick={() => fetchFeedback(false)}
            className="btn btn-primary bg-white hover:bg-pr_red hover:shadow-xl rounded-xl min-w-[150px] lg:min-w-[180px] p-1 flex items-center justify-center duration-500 border-0 text-black"
          >
            {userFeedback === false ? (
              <div className="flex items-center gap-3 px-3">
                <h6>تحلیل نادرست</h6>
                <AiFillDislike size={25} style={{ color: "text-pr_primary" }} />
              </div>
            ) : (
              <div className="flex items-center gap-3 px-3">
                <h6>تحلیل نادرست</h6>
                <AiOutlineDislike
                  size={25}
                  style={{ color: "text-pr_primary" }}
                />
              </div>
            )}
          </button>
        </div>
      </div>

      {userFeedback !== null && (
        <div className="mt-10 border-[1px] border-white p-5 rounded-xl">
          <h2 className="mt-2 font-rokh font-[700] text-lg text-white text-center">
            اگه دلیل انتخابت رو هم بهمون بگی عالی می‌شه.
          </h2>

          <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex-1 w-full flex flex-col justify-between"
          >
            {userFeedback === false && (
              <div className="w-full mt-3">
                {commentItems.map((defaultComment: any, idx: number) => (
                  <Checkbox
                    key={idx}
                    id={defaultComment.value}
                    label={defaultComment.title}
                    checkedItems={checkedItems}
                    onChange={(id: any) =>
                      handleCheckboxChange(defaultComment.value)
                    }
                    isFullWidth
                  />
                ))}
              </div>
            )}

            <div className="w-full">
              <Textarea
                errors={[]}
                form={form}
                rows={3}
                placeholder=""
                id="feedback"
              />
            </div>

            <div className="mb-3 mx-auto w-3/12 ">
              <LoadingButton
                textColor="black"
                color="white"
                width="w-full"
                title="ارسال"
                type="submit"
                disabled={false}
                loading={feedbackLoading}
              />
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default UserComment;
